import whichTransitionEvent from '@/components/transition-event.js'

$(function() {
  const $drawer = $('#briq-drawer')
  const $drawerContent = $drawer.find('.app__drawer-content')
  let currentId = ''
  let closing = false
  let opened = false

  function closeDrawer($el) {
    closing = true
    $el
      .one(whichTransitionEvent(), function() {
        $drawer.trigger('drawer.closed')
      })
      .removeClass('active')
  }

  $(document).on('keyup', function(e) {
    e.which == 27 && closeDrawer($drawer)
  })

  $('body')
    .on('click.drawer', '[data-toggle="drawer"]', function(e) {
      if (!closing) {
        var $el = $(this),
          id = $el.attr('data-id')

        // Prevent table actions from triggering the drawer
        if ($(e.target).parents('.table__actions').length) {
          return
        }

        if ($drawer.hasClass('active') && currentId == id) {
          closeDrawer($drawer)
        } else {
          if (currentId) {
            $('[data-id="' + currentId + '"]').removeClass('active')
          }

          currentId = id

          $drawer.addClass('active').trigger({
            type: 'drawer.opening',
            url: $el.attr('data-url'),
          })
        }
      }
    })
    .on('click.drawer', '[data-dismiss="drawer"]', function() {
      closeDrawer($drawer)
    })
    .on('drawer.close', function() {
      closeDrawer($drawer)
    })
    .on('click', function(e) {
      if (opened) {
        var $target = $(e.target)

        if ($(e.delegateTarget).hasClass('modal-open')) {
          return
        }

        if ($target.closest('#context-menu').length) {
          return
        }

        if ($target.closest('#briq-modal').length) {
          return
        }

        if (
          $target.closest('#briq-drawer').length === 0 &&
          $target.closest('[data-toggle="drawer"]').length === 0
        ) {
          closeDrawer($drawer)
        }
      }
    })

  $drawer
    .on('drawer.opening', function(e) {
      $('[data-id="' + currentId + '"]').addClass('active')

      $.ajax(e.url, {
        dataType: 'json',
      }).then(
        function(value) {
          $drawerContent.html(value.html)
          $drawer.trigger('bless')
          opened = true
        },
        function(jqXHR, textStatus) {
          $drawerContent.html('Loading failed: <pre>' + textStatus + '</pre>')
          opened = true
        },
      )
    })
    .on('drawer.closed', function() {
      if (currentId) {
        $('[data-id="' + currentId + '"]').removeClass('active')
      }
      $drawerContent.html('<div class="feedback">Loading</div>')
      closing = false
      opened = false
    })
})
